module.exports = "<div class=\"resize-icon\"\n     ng-click=\"$ctrl.toggleMinimize()\"\n     ctx-tooltip\n     tooltip-info=\"{{($ctrl.isMini ? 'vm.subTable.detail.actionMaximize.label' : 'vm.subTable.detail.actionMinimize.label')|translate}}\">\n    <i class=\"icon-min-max icon-Minimize\"></i>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/minimizeButtonToggle/minimizeButtonToggle.component.html
// module id = 296
// module chunks = 0 1